<template>
  <section
    class="max-h-[152px] overflow-auto rounded-4 bg-elev-context-menu-bg text-fg-base-fg3 shadow-all-0030-black-50 will-change-scroll"
  >
    <header
      class="flex items-center border-b border-bor-nav px-2 py-[0.3rem]"
    >
      <span
        class="mr-2 text-2432 whitespace-nowrap"
        data-test="reaction-info-emoji"
      >{{ emoji }}</span>
      <span
        class="text-1315 whitespace-nowrap text-fg-base-fg3"
        data-test="reaction-info-authors-count"
      > {{ countMemberTextView }}</span>
    </header>
    <div
      class="px-3 pb-2"
    >
      <reaction-author
        v-for="author in authorsList"
        :key="author"
        :author="author"
        class="text-1316 whitespace-nowrap text-fg-base-fg3"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { getTextForDifferentCount } from '@/shared/utils/get-text-for-different-count'

import { ReactionData, Emoji } from '../store'

import ReactionAuthor from './reaction-author.vue'

const props = defineProps<{
  emoji: Emoji
  reactionData: ReactionData
}>()

const { tc } = useLocalization()

const wordsForCountMemberText = {
  forOne: tc('common.participant', 0),
  forTwo: tc('common.participant', 1),
  forFive: tc('common.participant', 2),
}

const authorsList = computed(() => Array.from(props.reactionData.authors))

const countMemberTextView = computed(() =>
  getTextForDifferentCount(props.reactionData.authors.size, wordsForCountMemberText),
)
</script>
